export default __webpack_public_path__ + "static/media/webchat.2051f246.svg";